export const API_URL = "https://testrsapi.realtyspacehub.com/api/"